import { localUrlEnum } from "../urlEnum";
import { Vocabulary } from "../Vocabulary";
import CampaignIcon from "@mui/icons-material/Campaign";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

export const ROUTER_VIEW_XAUTO_VEHICLES_REQUESTS = {
  routes: [
    localUrlEnum.xautoVehicles,
    localUrlEnum.xautoVehiclesActive,
    localUrlEnum.xautoVehiclesDeactivated,
    "*",
  ],
};
export const MAIN_SLIDER_VIEW_XAUTO_VEHICLES = [
  {
    name: Vocabulary.xauto,
    icon: <CampaignIcon />,
    orderId: 1.5,
    group: Vocabulary.navGroupVehicles,
    subMenu: [
      {
        name: Vocabulary.xautoVehiclesActive,
        path: localUrlEnum.xautoVehiclesActive,
        icon: <CheckCircleOutlineIcon />,
        orderId: 1.51,
      },
      {
        name: Vocabulary.xautoVehiclesDeactivated,
        path: localUrlEnum.xautoVehiclesDeactivated,
        icon: <HighlightOffIcon />,
        orderId: 1.52,
      },
    ],
  },
];
